export const TestResultSectionDataP63 = (selectedTag, formData) => ({
    rows: [
        {
            key: 1,
            fields: [
                {
                    key: 'F143HmireadingAfterTestLabel',
                    label: 'HMI Reading after Test',
                    xs: 2,
                    padding: '5px 0 0 0',
                    isLabel: 'true',
                    labelWidth: '97%',
                    textAlign: 'left',
                    fontSize: '9pt',
                    fontWeight: '600',
                },
                {
                    key: 'F143HmireadingAfterTest',
                    value: formData.F143HmireadingAfterTest,
                    isRequired: true,
                    xs: 2,
                    type: 'number',
                    maxLength: '10',
                    labelWidth: '0',
                    width: '100%',
                    height: '1.2rem',
                    textAlign: 'center'
                },
                {
                    key: 'NodataP632',
                    isLabel: true,
                    xs: 1
                },
                {
                    key: 'F267ProcessTxreadingAfterTestLabel',
                    label: 'Process TX Reading after Test',
                    labelWidth: '98%',
                    xs: 3,
                    height: '1.2rem',
                    padding: '5px 0 0 0',
                    isLabel: 'true',
                    textAlign: 'end',
                    fontSize: '9pt',
                    fontWeight: '600',
                    borderBottom: '0',
                },
                {
                    key: 'F267ProcessTxreadingAfterTest',
                    value: formData.F267ProcessTxreadingAfterTest,
                    isRequired: true,
                    type: 'number',
                    maxLength: '10',
                    xs: 4,
                    labelWidth: '0',
                    height: '1.2rem',
                    textAlign: 'center',
                    width: '100%',
                    marginLeft: '0.8px'
                },
            ]
        }]
});
